import {useState, useEffect} from "react"
import {Aff_question} from "./Aff_question"
import {ButtonHtml} from "../html/ButtonHtml"
import {MathJaxContext } from "better-react-mathjax";
import {Mode_classe} from "./Mode_classe"
import {affiche_param} from "../Fonctions"
import {Chargement} from "./Chargement"

export function Erreurs ({auth}) {

	const [selection, setSelection] = useState({
		classe:'',
		erreurs:'',
		activite:'',
		niv:'',
		msg:'',
		nb_activite:10,
		signalActivite:'',
		signaledQuestions:[],
		show_erreurs:false,
		show_signal_question:false,
	})
	const [mode_classe, setMode_classe] = useState(false)
	const [loading, setLoading] = useState(false)

	const handleClick = (e) => {
		const param = e.target.id
		const erreurs = selection.erreurs
		const value = e.target.attributes.name.value
		const niv = e.target.attributes.niv.value
		const activite = e.target.attributes.title.value
		let numQuestions = []
		if (param === 'signalActivite') {
			selection.erreurs.signalQuestion.forEach(e => {
				if(e.activite === value && !numQuestions.includes(e.num_question.split('_')[1])) {numQuestions.push(e.num_question.split('_')[1])}
			})
			fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
		    method: 'POST',
		    body: JSON.stringify({...auth, action:'recupSignalQuestion', niveau:niv, numQuestions})
		  })
		  .then(response => response.json())
		  .then(data => {
		  	let questionsNonComprises = []
		  	numQuestions.forEach((e,k)=>{
		  		let elt ={eleves:[]}
		  		elt.num = e
		  		elt.question = data[k]
		  		selection.erreurs.signalQuestion.forEach(q=>{
			  			if(q.num_question.split('_')[1] === e){elt.eleves.push(q.id_eleve.split('_')[0])}
			  		})
		  		questionsNonComprises.push(elt)
		  	})
		  	//console.log('selection', selection)
				setSelection({...selection, niv, activite, signaledQuestions:questionsNonComprises, show_erreurs:false, show_signal_question:true})
		  })
		  .catch(err => console.log(err))
		} else {
			setSelection({...selection, erreurs, [param]:value, niv, msg:'', show_erreurs:activite === selection.activite ? !selection.show_erreurs : true, show_signal_question:false})
		}
	}

	const handleSubmit = (e) => {
		//console.log(selection.classe)
	  let	classe = e.target.innerText
	  let	msg=''
		let erreurs = ''
		let nb_activite = 10
		setLoading(true)
		setSelection({...selection, erreurs:''})
	  fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
	    method: 'POST',
	    //body: JSON.stringify({...auth, action:'recup_erreurs', classe:selection.classe})
	    body: JSON.stringify({...auth, action:'recup_erreurs', classe})
	  })
	  .then(response => response.json())
	  .then(data => {
	    //console.log('data', data)
	    //return
	    if(Array.isArray(data.questions)) {
	    	msg='<div class="info"><br>Il n\'y a pas d\'erreur répertoriée pour cette classe.<br><br></div>'
	    } else {erreurs = data}
	    setSelection({...selection, erreurs, classe, activite:'', msg, nb_activite, niv:Object.keys(data)[0], signaledQuestions:[], show_erreurs:false, show_signal_question:false,})
		setLoading(false)
	  })
	  .catch(err => console.log(err))
	}

	useEffect(()=>{
	  if(typeof window?.MathJax !== "undefined"){
	    window.MathJax.typeset()
	  }
	},[selection, mode_classe]); // MathJax 

	//const affiche_classes = (classes, classe_selected, handleClick) => Object.keys(classes).map((e, k)=><span key={k} className={'btn_param' + (classe_selected === e ? ' active' : '')} id='classe' onClick={handleClick}>{e}</span>)
	const affiche_activ_erreurs = () => {
		let result = ''
		let tab_activ = []
		if (selection.erreurs){
			//tab_activ = Object.keys(selection.erreurs.questions).map((niv, k)=><span key={k}></span>)
			Object.keys(selection.erreurs.questions).forEach(niv=>{
				Object.keys(selection.erreurs.questions[niv]).forEach((activite, k)=>{
					//console.log(activite)
					const activ = activite.replace('2e devoir mêmes notions__', '').replace('3e devoir mêmes notions__', '')
					tab_activ.push(<span key={niv + k} name={activite} className={'btn_param' + (selection.activite === activite ? ' active' : '')} id='activite' title={activite} niv={niv} onClick={handleClick}>{auth.activite_faites[selection.classe][activite][0].title || (activ.length > 30 ? activ.slice(0,30)+'...' : activ)}</span>)
				})
			})
			let tab_activ2 = tab_activ.slice(0,selection.nb_activite)
			//  Gestion du btn '...'
			if(selection.nb_activite < 1000 && tab_activ.length > 10) {
				tab_activ2.push(<span key={'end...'} className="btn_param" onClick={()=>{
	    							const nb = selection.nb_activite
	    							const add = Object.keys(auth.activite_faites[selection.classe]).length < nb ? 1000 : 10
	    							setSelection({...selection, nb_activite:nb+add > selection.nb_activite ? 1000 : nb+add})
	    						}}>...</span>)
			}
			//======================
			
			result = <span>
									{selection.activite === '' && <span>
										<br/><div><b>▸ Choisir une activité faite avec les élèves du groupe {selection.classe} :</b></div> <br/>
									</span>}
									{[<span title='Erreurs des élèves' style={{fontSize:'1.5em'}}>⚡</span>, tab_activ2]}
							</span>
		}
		return result
	}

	const affiche_signalQuestion = () => {
		let result = ''
		let tab_activ = []
		let tab_activ2 = []
		selection.erreurs.signalQuestion.forEach((elt,k) => {
			if(!tab_activ.includes(elt.activite)){
				tab_activ.push(elt.activite)
				tab_activ2.push(<span 
					key={'QS' + k} 
					name={elt.activite} 
					id='signalActivite'
					niv={elt.num_question.split('_')[0]}
					className={'btn_param' + (selection.activite === elt.activite ? ' active' : '')} 
					onClick={handleClick}
					title={elt.activite}>
					{auth.activite_faites[selection.classe][elt.activite][0].title || (elt.activite.length > 30 ? elt.activite.slice(0,30)+'...' : elt.activite)} 

					</span>)
			}
		})

		result = tab_activ2
		return [<span title='Questions non comprises' style={{fontSize:'1.5em'}}>❓</span>, result]
	}

	const affiche_reponse = (quest) => {
		const rep = quest.length === 4 ? quest[3][0] : (quest[4]+'').split('_')[0]
		let debut = ''
		if(quest.length === 5 && (quest[4]+'')?.includes('_')){
			debut =  'Une réponse attendue était'
		} else {
			debut =  'La réponse attendue était'
		}
		return <>
				{debut} <span style={{color:'#314159', fontWeight:'bold'}}>{rep}</span>. <br/>
			</>
	}

	const handleSupprSignaledQuestion = (e) => {
		let choix = window.confirm('Voulez-vous vraiment supprimer ce signalement ?')
		if(choix) {
			fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
		    method: 'POST',
		    body: JSON.stringify({...auth, action:'supprSignalquestion', niveau:selection.niv, classe:selection.classe, numQuestion:selection.niv + '_' + e.target.id})
		  })
		  .then(response => response.json())
		  .then(data => {
		  	const NewSignaledQuestion = selection.signaledQuestions.filter(q=>q.num !== e.target.id)
		  	const NewSignalQuestion = selection.erreurs.signalQuestion.filter(q=>q.num_question !== selection.niv + '_' + e.target.id)
		  	const newErreurs = {...selection.erreurs, signalQuestion:NewSignalQuestion}
		  	setSelection({...selection, signaledQuestions:NewSignaledQuestion, erreurs:newErreurs})
		  })
		  .catch(err => console.log(err))
		}
	}
	function Reponse (rep) {
	  if (Array.isArray(rep.rep[3])){
	    return <div className={rep.rep[3].length===3 ? 'reponse qcm c3' : 'reponse qcm'}>
	      {rep.rep[3].map((elt, k)=> 
	        !(elt+'').includes('checkbox') ? 
	          <label key={k}> 
	            <input className="radio" type={rep.rep[3].includes('checkbox1') || rep.rep[3].includes('checkbox2') || rep.rep[3].includes('checkbox3') ? 'checkbox' : 'radio'} /> {<span dangerouslySetInnerHTML={{ __html:(elt+'').replace('src="', 'src="https://maths-au-quotidien.fr/images/automaths/')}}></span>}
	          </label>
	        :''
	      )}
	    </div>
	  } else {
	    return <div className="reponse" dangerouslySetInnerHTML={{ __html:rep.rep[3]}}></div>
	  }
	}

	//console.log('selection', selection)
	//console.log('auth', auth)
	//console.log('signaledQuestions', selection.signaledQuestions)
	//console.log('auth.activite_faites[selection.classe]', auth.activite_faites[selection.classe])
	//console.log(selection.erreurs.questions[selection.niv][selection.activite])
	//console.log('selection.erreurs.questions', selection.erreurs.questions)
	//console.log('nb_activite', selection.nb_activite)
  return (
    <div className="content max" style={{textAlign:'left'}} >
    <h1>Les erreurs commises par les élèves...</h1>
    	{selection.classe === '' && <span>
	    		Dans cette partie, visualisez les erreurs commises par vos élèves. <br/>
	    		Pour chaque activité, les questions affichées sont classées du plus grand au plus petit nombre d'erreurs.<br/>
	    		<div><b>▸ Choisir une classe :</b></div><br/>
	    	</span>
    	}
    	{affiche_param(auth.mes_classes, selection.classe, 'classe', handleSubmit)}
    	
    	{loading && <Chargement />}
    	<br/>
    	{affiche_activ_erreurs()}

    	{<div dangerouslySetInnerHTML={{ __html:selection.msg}}></div>}

    	{
    		//Object.keys(auth.mes_classes).map((e, k)=><span key={k} className={'btn_param' + (selection.classe === e ? ' active' : '')} id='classe' onClick={handleSubmit}>{e}</span>)
    	}

    	{/*
    		selection.erreurs ? <div>
		    			<br/>Veuillez choisir une activité faite en {selection.classe}   : <br/><br/>
		    			{Object.keys(selection.erreurs.questions).map((niv, k)=><span key={k}>
		    				{Object.keys(selection.erreurs.questions[niv]).map((act, k2)=>k2 < selection.nb_activite && <span key={k2} className={'btn_param' + (selection.activite === act.replace('2e devoir mêmes notions__', '') ? ' active' : '')} id='activite' title={act} niv={niv} onClick={handleClick}>{auth.activite_faites[selection.classe][act.replace('2e devoir mêmes notions__', '')][0].title || (act.length > 30 ? act.slice(0,30)+'...' : act)}</span>)}
		    				</span>)}
		    			{selection.nb_activite < 1000 && <span className="btn_param" onClick={()=>{
		    							const nb = selection.nb_activite
		    							const add = Object.keys(auth.activite_faites[selection.classe]).length < nb ? 1000 : 10
		    							setSelection({...selection, nb_activite:nb+add > selection.nb_activite ? 1000 : nb+add})
		    						}}>...</span>
		    			}
		    		</div> : ''*/
    	}
    	{(selection.erreurs && selection.activite && selection.show_erreurs) && <div style={{position:'relative', height:'30px'}}> 
    				<div name="mode_classe" className="mode_classe" onClick={()=>setMode_classe(true)}></div>
    			</div>
    	}
    	<MathJaxContext>{(selection.erreurs && selection.activite && selection.show_erreurs) && Object.keys(selection.erreurs.questions[selection.niv][selection.activite]).sort((a,b)=>selection.erreurs[selection.niv][selection.activite][b]-selection.erreurs[selection.niv][selection.activite][a]).map((quest, kquest)=>
				<span key={kquest}>
    			<Aff_question question={selection.erreurs.questions[selection.niv][selection.activite][quest]} num_quest={selection.erreurs[selection.niv][selection.activite][quest]+' échecs : '} />
				</span>
					
				
    	)}</MathJaxContext> 

    	{mode_classe ? 
    	      <div className='modal active'>
    	          <div className="suppr_serie" onClick={e=>setMode_classe(false)}></div>
        				<Mode_classe auth={{...auth, titre:auth.activite_faites[selection.classe][selection.activite.replace('2e devoir mêmes notions__', '').replace('3e devoir mêmes notions__', '')][0].title || (selection.activite.length > 30 ? selection.activite.slice(0,30)+'...' : selection.activite), questions:Object.values(selection.erreurs.questions[selection.niv][selection.activite])}} setMode_classe={setMode_classe} />
    	      </div> :''
    	}

    	{/*
    		selection.erreurs && Object.keys(selection.erreurs.questions).map((niv, k)=>
    			<div key={k}>
    				<b>Niveau {niv} :</b> <br/>
    				{Object.keys(selection.erreurs.questions[niv]).map((act, k2)=> 
    					<div key={k2} id="erreurs" onClick={e=>{
						    				document.querySelector('#erreurs .active')?.classList.remove('active')
						    				e.target.className = e.target.id === 'erreurs' ? 'active' : e.target.className
						    			}}>
    						<div dangerouslySetInnerHTML={{ __html:act.replaceAll('__', '<br>')}}></div>
    						<div>{selection.erreurs.questions[niv][act].map((quest, kquest)=>
    							<Aff_question key={kquest} question={quest} />
    							)}</div>

    					</div>
    					)
    				}
    			</div>
    			)*/
    	}

    	{
    		selection.erreurs.signalQuestion?.length > 0 && <div>
	    		{
	    			!selection.show_signal_question &&
	    			<>
	    				<br/><hr/>
	    				<h1>Les questions à réponse non comprise</h1>
	    				Des élèves du groupe <b>{selection.classe}</b> ont signalé des questions dont la réponse n'a pas été comprise : <br/>
	    			</>
	    		}
	    		{affiche_signalQuestion()}
	    		<br/>
	    		{(selection.signaledQuestions.length > 0 && selection.show_signal_question) && 
	    			<>
	    			{selection.signaledQuestions.map((e, k)=>
	    					<div key={'signal' + k} className="page">
	    					<div className="enonce">
					        <h1>{e.question[0]}</h1>
					        <h2>{e.question[1].replaceAll('*', '⭐').replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/')}</h2>
					        <div dangerouslySetInnerHTML={{ __html:e.question[2].replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/')}} ></div>
					        <Reponse rep={e.question} />
      						<br/><hr/>
	    					{affiche_reponse(e.question)}
	    					Cette réponse n'a pas été comprise par <span style={{color:'#314159', fontWeight:'bold'}}>{[...new Set(e.eleves)].join(', ')}</span>.<br/><br/>

	    						<ButtonHtml 
	    							value={'Supprimer'} 
	    							onClick={handleSupprSignaledQuestion}
	    							className={'blue'}
	    							id={e.num}
	    						/>
      						<br/><br/>
					      </div>
	    					</div>
	    					
	    			)}
	    			</>
	    		}
	    	</div>
    	 }
    </div>
  );
}